import { render, staticRenderFns } from "./AboutSectionHeading.vue?vue&type=template&id=3740ff90"
import script from "./AboutSectionHeading.vue?vue&type=script&lang=js"
export * from "./AboutSectionHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports